import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MfaRecoveryConfirmRequest,
  MfaRecoverySetupRequest,
  TotpSetupResponse,
} from 'src/app/models/mfa/mfa.model';
import { ApiService } from '../api.service';

/** MFA recovery after an admin reset. The user can't sign in until it's finished, so requests go without auth. */
@Injectable()
export class MfaRecoveryService {
  private readonly BASE_URL = 'users/mfa/recovery';

  constructor(private apiSvc: ApiService) {}

  /** Step 1 — requires the current password, returns the new authenticator secret. */
  setup(payload: MfaRecoverySetupRequest): Observable<TotpSetupResponse> {
    return this.apiSvc.post<TotpSetupResponse>(`${this.BASE_URL}/setup`, payload, {}, false);
  }

  /** Step 2 — confirms the new secret with a code generated from it. */
  confirm(payload: MfaRecoveryConfirmRequest): Observable<void> {
    return this.apiSvc.post<void>(`${this.BASE_URL}/confirm`, payload, {}, false);
  }
}
